"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var TimeOptions = /** @class */ (function (_super) {
    __extends(TimeOptions, _super);
    function TimeOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genTimes = function () {
            var _a = _this.props, minuteStep = _a.minuteStep, disablePast = _a.disablePast, disableFuture = _a.disableFuture, value = _a.value;
            var timeOfDay = moment_timezone_1.default().set({ hour: 0, minute: 0, seconds: 0 });
            var nextDay = timeOfDay.clone().add(1, 'day');
            var times = [];
            var nowMinutes = parseInt(moment_timezone_1.default().format('H'), 10) * 60 + moment_timezone_1.default().get('minute');
            for (var i = 0; timeOfDay.isBefore(nextDay); i++) {
                var clone = timeOfDay.clone();
                var cloneMinutes = parseInt(clone.format('H'), 10) * 60 + clone.get('minute');
                if (value.isSame(timeOfDay, 'day')) {
                    if (disablePast || disableFuture) {
                        if (disablePast && cloneMinutes > nowMinutes) {
                            times.push(clone);
                        }
                        if (disableFuture && cloneMinutes < nowMinutes) {
                            times.push(clone);
                        }
                    }
                    else {
                        times.push(clone);
                    }
                }
                else {
                    times.push(clone);
                }
                timeOfDay.add(minuteStep, 'minutes');
            }
            return times;
        };
        _this.genClasses = function (option) {
            var _a = _this.props, value = _a.value, timeFormat = _a.timeFormat;
            var classes = 'time-option';
            if (value.format(timeFormat) === option.format(timeFormat)) {
                classes += ' selected';
            }
            return classes;
        };
        return _this;
    }
    TimeOptions.prototype.render = function () {
        var _this = this;
        var _a = this.props, timeFormat = _a.timeFormat, reducer = _a.reducer;
        var times = this.genTimes();
        return (React.createElement("div", { className: "time-wrap" }, times.map(function (option, i) { return (React.createElement("div", { onClick: function () { return reducer({ action: 'selectTime', payload: { date: option } }); }, className: _this.genClasses(option), key: i }, option.format(timeFormat.match(/(:s?s)/) ? timeFormat.replace(/(:s?s)/, '') : timeFormat))); })));
    };
    return TimeOptions;
}(React.Component));
exports.default = TimeOptions;
